import { render, staticRenderFns } from "./KelaBatchDetailPanel.vue?vue&type=template&id=426aaa88&scoped=true&"
import script from "./KelaBatchDetailPanel.vue?vue&type=script&lang=js&"
export * from "./KelaBatchDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./KelaBatchDetailPanel.vue?vue&type=style&index=0&id=426aaa88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426aaa88",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VCol,VIcon,VRow,VSimpleTable,VSnackbar,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('426aaa88')) {
      api.createRecord('426aaa88', component.options)
    } else {
      api.reload('426aaa88', component.options)
    }
    module.hot.accept("./KelaBatchDetailPanel.vue?vue&type=template&id=426aaa88&scoped=true&", function () {
      api.rerender('426aaa88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KelaBatch/KelaBatchDetailPanel.vue"
export default component.exports